import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import Marquee from "react-fast-marquee";
import { scrollToId } from "../lib/content";

const VEGAS_IMG = "https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

export const ParallaxDivider = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-14%", "14%"]);
  const textY = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section ref={ref} className="relative h-[62vh] md:h-[74vh] overflow-hidden border-y border-white/10" data-testid="parallax-divider">
      <motion.img
        src={VEGAS_IMG}
        alt="City lights at night in Nevada"
        className="absolute inset-0 w-full h-[128%] -top-[14%] object-cover"
        style={{ y }}
      />
      <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(8,8,8,0.92) 0%, rgba(8,8,8,0.45) 50%, rgba(8,8,8,0.92) 100%)" }} />
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 30% 60%, rgba(124,58,237,0.22), transparent 55%)" }} />
      <motion.div style={{ y: textY }} className="relative h-full flex flex-col items-start justify-center px-6 md:px-12 max-w-[1440px] mx-auto">
        <p className="font-mono-c text-[10px] tracking-[0.35em] mb-5" style={{ color: "#c4b5fd" }}>THE DOOR IS CLOSER THAN YOU THINK</p>
        <h2 className="font-display font-bold uppercase text-[#F0ECE4]" style={{ fontSize: "clamp(30px, 4.4vw, 62px)", lineHeight: 1.0, letterSpacing: "-0.02em", textShadow: "0 4px 40px rgba(0,0,0,0.8)" }}>
          The Right Keys Are<br />
          <span style={{ color: "#a78bfa" }}>Information, Not Luck.</span>
        </h2>
        <button onClick={() => scrollToId("register")} className="btn-accent mt-9 px-8 py-4 text-[13px]" data-testid="divider-cta">
          ✓ RESERVE MY FREE SEAT
        </button>
      </motion.div>
      <p className="absolute bottom-5 right-6 md:right-12 font-mono-c text-[10px] tracking-[0.35em] text-white/45" data-testid="divider-city-tag">📍 NEVADA</p>
    </section>
  );
};

export const BigMarquee = () => (
  <div className="py-10 border-t border-black/10 overflow-hidden" data-testid="big-marquee">
    <Marquee speed={22} gradient={false} autoFill>
      <span className="font-display font-bold uppercase whitespace-nowrap mx-6" style={{ fontSize: "clamp(56px, 8vw, 120px)", lineHeight: 1, letterSpacing: "-0.03em", color: "transparent", WebkitTextStroke: "1px rgba(124,58,237,0.45)" }}>
        RESERVE YOUR SEAT
      </span>
      <span className="font-display font-bold mx-6" style={{ fontSize: "clamp(30px, 4vw, 60px)", color: "#7C3AED" }}>◆</span>
      <span className="font-display font-bold uppercase whitespace-nowrap mx-6" style={{ fontSize: "clamp(56px, 8vw, 120px)", lineHeight: 1, letterSpacing: "-0.03em", color: "rgba(0,0,0,0.08)" }}>
        SEPT 17 · 6PM PDT
      </span>
      <span className="font-display font-bold mx-6" style={{ fontSize: "clamp(30px, 4vw, 60px)", color: "#7C3AED" }}>◆</span>
    </Marquee>
  </div>
);
